module.exports = __webpack_public_path__ + "img/Aaron_O_2.2a78a715.jpg";